import i18n from 'i18next';
import { take, select, put, call } from 'redux-saga/effects';
import { Actions, setLanguage } from 'actions/shellActions';
import { Actions as SessionActions } from 'actions/sessionActions';
import { push as navigateTo } from 'connected-react-router';
import * as moment from 'moment-timezone';
import { getLoginUrl } from 'selectors/shellSelectors';

export function* changeLanguageSaga() {
    while (true) {
        const action: ReturnType<typeof setLanguage> = yield take(Actions.SET_LANGUAGE);
        const langCode = action.payload;
        yield call([ i18n, 'changeLanguage' ], langCode);

        const body = document.getElementsByTagName('body')[0];
        body.className = `lang-${langCode}`;

        moment.locale(langCode);
    }
}

export function* jumpToStoredLoginPage() {
    // Only do one time because we care about the landing page only.
    // Wait for a successful login and then redirect to the stored
    // landing page (if there was one)
    yield take(SessionActions.LOGIN_SUCCESS);

    const url: string = yield select(getLoginUrl);
    if (url !== 'login') {
        yield put(navigateTo(url));
    }
}